import { useState } from "react";
import { Alert, Card, CardBody, Form, FormGroup, Input, Label, InputGroup, InputGroupText } from "reactstrap";
import { login } from "../auth.api";
import { authService } from "../auth.service";
import SapButton from "../../../components/SapButton";
import { Link, useSearchParams } from "react-router-dom";
import HiddenTextInput from "../../../components/HiddenTextInput";

const getLoginErrorMessage = (errorCode: string) => {
    switch (errorCode) {
        case "ERR_SUSPENDED_TENANT":
            return "Your account has been suspended. Please contact SME Plus support.";
        case "ERR_INACTIVE_TENANT":
            return "Your account is inactive. Please contact SME Plus support.";
        default:
            return "Incorrect username or password.";
    }
};

export function Login() {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState("");
    const [inprogress, setInprogress] = useState(false);
    const [searchParams] = useSearchParams();

    const handleLogin = (e: any) => {
        e.preventDefault();
        setInprogress(true);
        setError("");
        login({ username: username.trim(), password: password.trim() })
            .then((res) => {
                if (res.succeeded) {
                    authService.storeAuthToken(res.authToken, res.refreshToken);
                    // Redirect to return URL or home page
                    const returnUrl = searchParams.get("returnUrl");
                    const redirectUrl = returnUrl ? decodeURIComponent(returnUrl) : "/";
                    window.location.replace(redirectUrl);
                } else {
                    setError(getLoginErrorMessage(res.errorCode));
                }
            })
            .catch((err) => {
                console.error(err);
                setError("Unknown Error. Please contact SME Plus support, if error continues.");
            })
            .finally(() => setInprogress(false));
    };

    return (
        <Card className="mt-5" style={{ width: "90%", maxWidth: "500px", margin: "0 auto" }}>
            <CardBody>
                <Form onSubmit={handleLogin}>
                    <FormGroup>
                        <Label>Username</Label>
                        <Input value={username} onChange={(e) => setUsername(e.target.value)} />
                    </FormGroup>
                    <FormGroup>
                        <Label>Password</Label>
                        <HiddenTextInput value={password} onChange={(value) => setPassword(value)} />
                    </FormGroup>
                    <FormGroup className="text-center">
                        <SapButton type="submit" color="dark" submitting={inprogress}>
                            Log in
                        </SapButton>
                    </FormGroup>
                    <FormGroup className="text-start">
                        <Link className="no-underline" to="/account/forget-password">
                            Forget Password?
                        </Link>
                    </FormGroup>
                    <FormGroup>{error && <Alert color="danger">{error}</Alert>}</FormGroup>
                </Form>
            </CardBody>
        </Card>
    );
}
